import { Bell } from '@tamagui/lucide-icons';
import {
  HeaderButton,
  HeaderButtonProps
} from '@unistocks/components/page/header/header-button/header-button';
import { useNotificationsGetUnreadNotificationsCountQuery } from '@unistocks/proxy/axios-client/NotificationsQuery';
import { PropsWithRef } from '@unistocks/types';
import { useRouter } from 'expo-router';
import React from 'react';
import { TamaguiElement } from 'tamagui';

export type NotificationIconProps = PropsWithRef<
  Omit<HeaderButtonProps, 'onPress' | 'Icon'>,
  TamaguiElement
>;

export const NotificationIcon: React.FC<NotificationIconProps> = props => {
  const router = useRouter();
  const { data: unreadNotifications, isSuccess } =
    useNotificationsGetUnreadNotificationsCountQuery();

  const hasUnreadNotifications = isSuccess && unreadNotifications > 0;

  return (
    <HeaderButton
      Icon={Bell}
      color={hasUnreadNotifications ? '$unistocks' : '$gray11'}
      hitSlop={20}
      badge={unreadNotifications}
      {...props}
      onPress={() => router.navigate('/(tabs)/notifications')}
    />
  );
};

NotificationIcon.displayName = 'NotificationIcon';
